import { TestIdDomain } from 'constants/testIds';

export const NewContactDrawerTestIds = {
  TYPE_RADIO: `${TestIdDomain.NEW_CONTACT}.type-radio`,
  FIRST_NAME_INPUT: `${TestIdDomain.NEW_CONTACT}.first-name-input`,
  LAST_NAME_INPUT: `${TestIdDomain.NEW_CONTACT}.last-name-input`,
  COMPANY_NAME_INPUT: `${TestIdDomain.NEW_CONTACT}.company-name-input`,
  EMAIL_INPUT: `${TestIdDomain.NEW_CONTACT}.email-input`,
  PHONE_INPUT: `${TestIdDomain.NEW_CONTACT}.phone-input`,
  LIFECYCLE_STAGE_SELECT: `${TestIdDomain.NEW_CONTACT}.lifecycle-stage-select`,
  PREFERRED_CONTACT_METHOD_SELECT: `${TestIdDomain.NEW_CONTACT}.preferred-method-select`,
  SUBMIT_BUTTON: `${TestIdDomain.NEW_CONTACT}.submit-button`,
};
